export const prebuiltViewNames = {
  allRecommendations: "All",
  assessmentRecommendations: "Assessments",
  cloudRecommendations: "Cloud",
};

export const recommendationsPrebuiltViews = [
  {
    name: prebuiltViewNames.allRecommendations,
    filters: [],
  },
  {
    name: prebuiltViewNames.assessmentRecommendations,
    filters: [{ accessor: "SourceSystem", value: "Assessments" }],
  },
  {
    name: prebuiltViewNames.cloudRecommendations,
    filters: [
      { accessor: "SourceSystem", value: "AzureSimpleRecommendations" },
    ],
  },
];

export const recommendationsDefaultPrebuiltView =
  recommendationsPrebuiltViews.find(
    (p) => p.name === prebuiltViewNames.allRecommendations,
  );
